import React, { useRef, useState } from "react";
import { makeStyles } from "@material-ui/core";
import DXFParser, { DxfParser } from "dxf-parser";
import JSZip, { file } from "jszip";
import CustomButton from "./CustomButton";
import { saveAs } from "file-saver";
import { injectIntlTranslation } from "@carrier-ecat/workflowui-globalfunctions";
import { injectIntl } from "react-intl";
import { constants } from "../../../constants/constants";

const DMUpload = ({ name, sendFileData, validateFile, intl }) => {
  const useStyles = makeStyles((theme) => ({
    formControl: {
      margin: "-16px 24px 0 0",
      minWidth: 80,
    },
    inputLabel: {
      fontSize: "12px",
    },
  }));

  const [loading, setLoading] = useState(true);
  const [isValid, setIsValid] = useState(false);
  const [fileContent, setFileContent] = useState("");
  const [fileName, setFileName] = useState("");
  const [zipFile, setZipFile] = useState(null);

  const [fileArray, setFileArray] = useState([]);
  const [fileError, setFileError] = useState("");

  const classes = useStyles();

  const validateFileName = (file) => {
    let isValidFile = false;
    const fileExt = "dxf";
    const fileName = file.split(".");
    isValidFile = fileName[1].trim().toLowerCase().startsWith(fileExt);
    const zipFile = fileName[0].concat(".zip").trim();
    setZipFile(fileName);
    setIsValid(isValidFile);
    validateFile(isValidFile);
    if (isValidFile) {
      setLoading(false);
    } else {
      setLoading(true);
    }
  };
  /* File upload*/
  const handleChange = async (e) => {
    const file = e.target.files[0];
    const allFiles = e.target.files;
    if (file !== undefined) {
      let tempFiles = [];
      let isValid = true;
      for (let i = 0; i < allFiles.length; i++) {
        var temp = allFiles[i];
        var fileExtension = temp.name.split(".").pop().toLowerCase();

        if (fileExtension !== "dxf") {
          isValid = false;
          setFileError(injectIntlTranslation(intl, "dxfFileError" , constants.dxfFileError));
          break;
        } else {
          tempFiles.push(temp);
        }
      }

      if (isValid) {
        await convertDXFtoZIP(tempFiles);
        // setFileArray(tempFiles);
      }
    } else {
      setLoading(true);
    }
  };

  const handleAddMoreFileChange = async (e) => {
    const file = e.target.files[0];
    const allFiles = e.target.files;
    if (file !== undefined) {
      let tempFiles = [];
      let isValid = true;
      for (let i = 0; i < allFiles.length; i++) {
        var temp = allFiles[i];
        var fileExtension = temp.name.split(".").pop().toLowerCase();

        if (fileExtension !== "dxf") {
          isValid = false;
          setFileError(injectIntlTranslation(intl, "dxfFileError" , constants.dxfFileError));
          break;
        } else {
          tempFiles.push(temp);
        }
      }

      if (isValid) {
        await convertDXFtoZIP(tempFiles, true);
        // setFileArray(tempFiles);
      }
    } else {
      setLoading(true);
    }
  };

  const convertToZipMew = async (ele) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (e) => {
        const contents = e.target.result;

        const zip = new JSZip();
        zip.file(ele.name, contents);
        zip
          .generateAsync({ type: "blob" })
          .then((content) => {
            let name = ele.name.split(".");
            const zipFileName = name[0].concat(".zip").trim();

            return { name: ele.name, file: content, zipFileName: zipFileName };
          })
          .then(resolve)
          .catch(reject);
      };
      reader.onerror = reject;
      reader.readAsArrayBuffer(ele);
    });
  };

  const updateAndOverWriteFiles = (newFiles, existingFiles) => {
    const fileMap = new Map();
    existingFiles.forEach((file) => {
      fileMap.set(file.name, file);
    });

    newFiles.forEach((file) => {
      fileMap.set(file.name, file);
    });

    return Array.from(fileMap.values());
  };

  const getZips = async (arr, isAddMore = false) => {
    Promise.all(arr).then((res) => {
      if (isAddMore) {
        let temp = updateAndOverWriteFiles(res, fileArray);
        setFileArray(temp);
      } else {
        setFileArray(res);
      }
    });
  };

  const convertDXFtoZIP = async (data, isAddMore = false) => {
    let temp = [];

    data.forEach(async (ele) => {
      const zipBlob = convertToZipMew(ele);
      temp.push({ name: ele.name, file: zipBlob });
    });

    getZips(
      temp.map((ele) => ele.file),
      isAddMore
    );
  };

  const saveFile = async () => {
    const payloadArr = fileArray.map((x) => {
      return {
        ...x,
        name: x.name.toLowerCase(),
        zipFileName: x.zipFileName.toLowerCase(),
      };
    });
    sendFileData(payloadArr);

    // const zip = new JSZip();
    // zip.file(fileName, fileContent);
    // zip.generateAsync({ type: "blob" }).then((content) => {
    //   saveAs(content, zipFile);
    //   sendFileData({
    //     fileName: zipFile,
    //     file: content,
    //   });
    // });
    // setLoading(true);
  };

  const fileInputRef = useRef(null);
  const addMoreFileRef = useRef(null);

  const handleIconClick = () => {
    fileInputRef.current.click();
  };

  const removeFiles = (data) => {
    let index = fileArray.indexOf(data);
    let temp = [...fileArray];

    if (index !== -1) {
      temp.splice(index, 1);
    }

    setFileArray([...temp]);
  };

  return (
    <div>
      <div style={{ minHeight: "200px" }}>
        {!fileArray.length && (
          <div
            style={{
              width: "93%",
              textAlign: "center",
              border: "1px dotted rgba(0, 0, 0, 0.23)",
              padding: "50px 20px",
              borderRadius: "4px",
              marginTop: "30px",
            }}
          >
            <div
              className="select-file-btn"
              onClick={() => {
                handleIconClick();
              }}
            >
              {injectIntlTranslation(intl, "selectDrawingToUpload" , constants.selectDrawingToUpload)}
            </div>
            <div style={{ fontSize: "12px", marginTop: "10px" }}>
              {injectIntlTranslation(intl, "selectDXFOnly" , constants.selectDXFOnly)}
            </div>
            {fileError && (
              <div
                style={{ fontSize: "12px", marginTop: "10px", color: "red" }}
              >
                {fileError}
              </div>
            )}
            <input
              type="file"
              ref={fileInputRef}
              style={{ display: "none" }}
              onChange={handleChange}
              accept=".dxf"
              multiple={true}
              max={5}
            ></input>
          </div>
        )}

        <div style={{ display: "flex" }}>
          {!!fileArray.length && (
            <div
              style={{ width: "100%", textAlign: "right", marginRight: "20px" }}
            >
              <div
                className="add-drawing-btn"
                onClick={() => {
                  addMoreFileRef.current.click();
                }}
              >
                {injectIntlTranslation(intl, "removeAllBaddMoreDrawingLabeltn" , constants.addMoreDrawingLabel)}
              </div>
              <input
                type="file"
                ref={addMoreFileRef}
                style={{ display: "none" }}
                onChange={handleAddMoreFileChange}
                accept=".dxf"
                multiple={true}
                max={5}
              ></input>
            </div>
          )}

          {fileArray.length > 1 && (
            <div style={{ width: "100px", textAlign: "right" }}>
              <div
                className="remove-all-btn"
                onClick={() => {
                  setFileArray([]);
                }}
              >
                {injectIntlTranslation(intl, "removeAllBtn" , constants.removeAllBtn)}
              </div>
            </div>
          )}
        </div>
        <div style={{ maxHeight: "500px", overflow: "auto" }}>
          {fileArray.length > 0 &&
            fileArray.map((ele) => {
              return (
                <div className="file-details">
                  <div
                    style={{
                      fontSize: "14px",
                      lineHeight: "20px",
                      flex: "1",
                      overflow: "hidden",
                      whiteSpace: "nowrap",
                      textOverflow: "ellipsis",
                    }}
                  >
                    {ele?.name}
                  </div>
                  <div
                    style={{
                      cursor: "pointer",
                      color: "red",
                      fontSize: "12px",
                      lineHeight: "20px",
                    }}
                    onClick={() => {
                      removeFiles(ele);
                    }}
                  >
                    {injectIntlTranslation(intl, "removeBtn" , constants.removeBtn)}
                  </div>
                </div>
              );
            })}
        </div>
      </div>
      <div className="save-action">
        <CustomButton
          id="Save-Btn"
          name={injectIntlTranslation(intl, "saveBtnLabel" , constants.saveBtnLabel)}
          color="primary"
          showGradient={true}
          fullWidth
          variant="contained"
          disabled={!fileArray.length}
          onClick={() => {
            saveFile();
          }}
        >
          {injectIntlTranslation(intl, "saveBtnLabel" , constants.saveBtnLabel)}
        </CustomButton>
      </div>
    </div>
  );
};

export default injectIntl(DMUpload);
